import Vue from 'vue'
import Vuex from 'vuex'
import tagsView from './tagsView'

Vue.use(Vuex)

const TOKEN_KEY = 'jz_token'
const USER_KEY = 'jz_user'

export default new Vuex.Store({
  modules: {
    tagsView
  },
  state: {
    token: localStorage.getItem(TOKEN_KEY) || '',
    user: JSON.parse(localStorage.getItem(USER_KEY) || 'null')
  },
  mutations: {
    setAuth(state, { token, user }) {
      state.token = token
      state.user = user
      localStorage.setItem(TOKEN_KEY, token)
      localStorage.setItem(USER_KEY, JSON.stringify(user))
    },
    patchUser(state, user) {
      state.user = Object.assign({}, state.user || {}, user)
      localStorage.setItem(USER_KEY, JSON.stringify(state.user))
    },
    logout(state) {
      state.token = ''
      state.user = null
      localStorage.removeItem(TOKEN_KEY)
      localStorage.removeItem(USER_KEY)
      sessionStorage.removeItem('permissions')
    }
  }
})
